export const calculateTotalLengthOfArrays = (...theArgs: unknown[]) =>
  theArgs.reduce(
    (totalLength: number, item) => (Array.isArray(item) ? totalLength + item.length : totalLength),
    0
  );
